import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { storesData } from "./storesData";
import FullScreenImageViewer from "./FullScreenImageViewer";
// Renamed the import to reflect the component's new purpose

const StoreMenuPage = () => {
  const { storeId } = useParams();
  const navigate = useNavigate();
  // Renamed state for clarity: it now holds menu data, not a single PDF
  const [viewingMenu, setViewingMenu] = useState(null);

  // Find the selected store by ID (this logic remains the same)
  const selectedStore = useMemo(() => {
    return storesData.find((s) => s.id === storeId) || null;
  }, [storeId]);

  useEffect(() => {
    if (!selectedStore) {
      // If no store found, go back home
      navigate(`/`, { replace: true });
      return;
    }

    // Auto-open the menu for the selected store
    // We now pass the entire menu object, not just one item
    if (selectedStore.menu && selectedStore.menu.images.length > 0) {
      setViewingMenu(selectedStore.menu);
    }
  }, [storeId, selectedStore, navigate]);

  // If the store is still being looked up, render nothing
  if (!selectedStore) return null;

  return (
    <>
      {/* Render the new ImageViewer component */}
      <FullScreenImageViewer
        // Pass the entire menu object as the 'menuData' prop
        menuData={viewingMenu}
        // When closed, clear the menu data state
        onClose={() => setViewingMenu(null)}
      />
    </>
  );
};

export default StoreMenuPage;